<template>
  <div class="homePage">
    <div class="fiex" :style="{ top: menuTop + 'px' }">
      <Navigation :active="3"></Navigation>
    </div>
    <div class="right">
      <div class="screen-box2">
        <div class="left">{{ $t("module.redemptionHistory.title1") }}</div>
      </div>
      <div class="list-box" ref="scrollContainer" @scroll="handleScroll">
        <div class="list-item" v-for="(item, index) in tableData2" :key="index">
          <div class="line-box">
            <div class="title">{{ item.giftName }}</div>
            <div class="content color2">
              <div
                class="participationStatus"
                v-if="item.statusDesc === '等待确认'"
              >
                <span style="background-color: #909090"></span>
                {{ $t("common.redemptionHistory.pendingConfirmation") }}
              </div>
              <div
                class="participationStatus"
                v-if="item.statusDesc === '等待审核'"
              >
                <span style="background-color: #fa8c16"></span>
                {{ $t("common.redemptionHistory.pendingReview") }}
              </div>
              <div
                class="participationStatus"
                v-if="item.statusDesc === '审核通过'"
              >
                <span style="background-color: #52c41a"></span>
                {{ $t("common.redemptionHistory.reviewApproved") }}
              </div>
              <div
                class="participationStatus"
                v-if="item.statusDesc === '审核拒绝'"
              >
                <span style="background-color: #ff4d4f"></span>
                {{ $t("common.redemptionHistory.reviewRejected") }}
              </div>
              <div
                class="participationStatus"
                v-if="item.statusDesc === '订单取消'"
              >
                <span style="background-color: #bfbfbf"></span>
                {{ $t("common.redemptionHistory.orderCancelled") }}
              </div>
              <div
                class="participationStatus"
                v-if="item.statusDesc === '订单完成'"
              >
                <span style="background-color: #1890ff"></span>
                {{ $t("common.redemptionHistory.orderCompleted") }}
              </div>
            </div>
          </div>
          <div class="line-box">
            <div class="title color1">{{ item.orderDate | dateFrom }}</div>
            <div class="content color3">-{{ item.displayPoints }}</div>
          </div>
          <div class="line-box2" v-if="item.url && item.status === 2">
            <div
              v-if="!item.receiveTime"
              class="unclaimed"
              @click="changeExchangeMethod(item.url, item.giftName)"
            >
              {{ $t("common.redemptionHistory.clickToClaim") }}
            </div>
            <div v-if="item.receiveTime" class="received">{{ $t("common.redemptionHistory.claimed") }}</div>
          </div>
        </div>
        <div class="flag" v-if="!flag && tableData2.length !== 0">
          {{ $t("common.redemptionHistory.loadMore") }}
        </div>
        <div class="flag" v-if="flag && tableData2.length !== 0">
          {{ $t("common.redemptionHistory.noMoreData") }}
        </div>

        <el-empty
          v-if="tableData2.length === 0"
          :description="$t('common.redemptionHistory.noData')"
        ></el-empty>
      </div>
      <div class="table-box">
        <div class="table-name">
          {{ $t("module.redemptionHistory.title1") }}
        </div>
        <el-table :data="tableData" height="820" border style="width: 100%">
          <el-table-column prop="number" :label="$t('common.redemptionHistory.transactionTime')" width="150">
            <template slot-scope="scope">
              {{ scope.row.orderDate }}
            </template>
          </el-table-column>
          <el-table-column prop="orderId" :label="$t('common.redemptionHistory.orderNumber')" width="170">
          </el-table-column>
          <el-table-column
            prop="giftName"
            :label="$t('common.redemptionHistory.prizeName')"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="displayPoints"
            :label="$t('module.redemptionHistory.title5')"
            width="100"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            :label="$t('common.redemptionHistory.claimStatus')"
            width="120"
          >
            <template slot-scope="scope">
              <div
                v-if="
                  !scope.row.receiveTime &&
                  scope.row.url &&
                  scope.row.status === 2
                "
                class="unclaimed"
                @click="changeExchangeMethod(scope.row.url, scope.row.giftName)"
              >
                {{ $t("common.redemptionHistory.clickToClaim") }}
              </div>
              <div
                v-if="
                  scope.row.receiveTime &&
                  scope.row.url &&
                  scope.row.status === 2
                "
                class="received"
              >
                {{ $t("common.redemptionHistory.claimed") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="participationStatus"
            :label="$t('module.redemptionHistory.title6')"
            width="120"
          >
            <template slot-scope="scope">
              <div
                class="participationStatus"
                v-if="scope.row.statusDesc === '等待确认'"
              >
                <span style="background-color: #909090"></span>
                {{ $t("common.redemptionHistory.pendingConfirmation") }}
              </div>
              <div
                class="participationStatus"
                v-if="scope.row.statusDesc === '等待审核'"
              >
                <span style="background-color: #fa8c16"></span>
                {{ $t("common.redemptionHistory.pendingReview") }}
              </div>
              <div
                class="participationStatus"
                v-if="scope.row.statusDesc === '审核通过'"
              >
                <span style="background-color: #52c41a"></span>
                {{ $t("common.redemptionHistory.reviewApproved") }}
              </div>
              <div
                class="participationStatus"
                v-if="scope.row.statusDesc === '审核拒绝'"
              >
                <span style="background-color: #ff4d4f"></span>
                {{ $t("common.redemptionHistory.reviewRejected") }}
              </div>
              <div
                class="participationStatus"
                v-if="scope.row.statusDesc === '订单取消'"
              >
                <span style="background-color: #bfbfbf"></span>
                {{ $t("common.redemptionHistory.orderCancelled") }}
              </div>
              <div
                class="participationStatus"
                v-if="scope.row.statusDesc === '订单完成'"
              >
                <span style="background-color: #1890ff"></span>
                {{ $t("common.redemptionHistory.orderCompleted") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="memo"
            width="120"
            :label="$t('module.redemptionHistory.title7')"
          >
          </el-table-column>
        </el-table>
        <div class="pagination-box">
          <el-pagination
            @size-change="getOrders(1)"
            @current-change="getOrders"
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size.sync="size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <ExchangeMethod
      v-if="isExchangeMethod"
      @close="isExchangeMethod = false"
      :url="url"
      :name="name"
    ></ExchangeMethod>
  </div>
</template>
<script>
import Navigation from "@/components/Navigation/side";
import { getOrders } from "@/api/user";

import ExchangeMethod from "@/components/mobileExchangeMethod";
export default {
  filters: {
    dateFrom(data) {
      const date = new Date(data);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份是从0开始的
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
  },
  data() {
    return {
      value: null,
      menuTop: 86,
      options: [
        {
          value: 1,
          label: "已完成",
        },
        {
          value: 2,
          label: "未完成",
        },
        {
          value: 3,
          label: "其它",
        },
      ],
      options2: [
        {
          value: 1,
          label: "已审核",
        },
        {
          value: 2,
          label: "待审核",
        },
        {
          value: 3,
          label: "其它",
        },
      ],
      tableData: [],
      page: 1,
      size: 10,
      total: 0,
      flag: false,
      page2: 1,
      size2: 10,
      tableData2: [],

      isExchangeMethod: false,
      url: null,
      name: null,
    };
  },
  components: { Navigation, ExchangeMethod },
  methods: {
    changeExchangeMethod(url, name) {
      (this.url = url || "11"), (this.name = name);
      this.isExchangeMethod = true;
    },
    listenScroll() {
      console.log(
        "1111",
        document.body.offsetHeight - document.scrollingElement.scrollTop,
        window.innerHeight
      );
      if (
        document.body.offsetHeight - document.scrollingElement.scrollTop <=
        845
      ) {
        this.menuTop =
          document.body.offsetHeight -
          document.scrollingElement.scrollTop -
          815; //，添加el-menu-item,增加730的数值,减少707相同数值
      } else {
        this.menuTop = 86;
      }
    },
    getOrders(type) {
      if (type) {
        this.page = type;
      }
      getOrders({
        page: this.page,
        size: this.size,
      }).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data.list;
          this.total = res.data.dataCount;
        }
      });
    },

    getOrders2(type) {
      if (type) {
        this.page2 = type;
        this.flag = false;
        this.tableData2 = [];
      }

      if (this.flag) {
        return;
      }
      getOrders({
        page: this.page2,
        size: this.size2,
      }).then((res) => {
        if (res.code === 200) {
          if (res.data.list.length > 0) {
            this.tableData2 = this.tableData2.concat(res.data.list);
            if (res.data.list.length === 10) {
              this.page2++;
            } else {
              this.flag = true;
            }
          }
        }
      });
    },

    handleScroll(e) {
      const container = this.$refs.scrollContainer;
      // 检查是否接近底部
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight
      ) {
        // 触底逻辑，例如加载更多数据
        console.log("触底");
        this.getOrders2();
      }
    },
  },
  created() {
    window.addEventListener("scroll", this.listenScroll);
    this.getOrders();
    this.getOrders2();
  },
  mounted() {},
  destroyed() {
    window.removeEventListener("scroll", this.listenScroll);
  },
};
</script>

<style lang="scss" scoped>
.homePage {
  min-height: 500px;
  display: flex;
  justify-content: flex-end;
  .fiex {
    position: fixed;
    left: 140px;
    transition: top ease 0.1s;
  }
  .right {
    flex-shrink: 0;
    width: calc(100% - 480px);
    margin-right: 140px;
    padding-top: 16px;
  }
}

//表格
.table-box {
  // margin-top: 16px;
  height: 960px;
  margin-bottom: 24px;
  background-color: #fff;
  .table-name {
    font-size: 16px;
    color: #474f66;
    padding: 20px 0 20px 20px;
    font-weight: bolder;
  }
  .pagination-box {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
    margin-right: 25px;
  }
}
.participationStatus {
  color: #474f66;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    width: 7px;
    height: 7px;
    border-radius: 3.5px;
    margin-right: 10px;
  }
}
.Auditing {
  color: #8948ff;
}

// 筛选移动端
.screen-box2 {
  display: none;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .left {
    font-size: 16px;
    color: #232323;
  }
  .el-select {
    width: 100px;
  }
}

//列表移动端
.list-box {
  display: none;
  max-height: 500px;
  overflow: auto;
  margin-top: 15px;
  margin-bottom: 25px;
  .list-item {
    width: 100%;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    margin-bottom: 10px;
    padding: 17px 0 17px 0;
    .line-box {
      padding: 0 15px 0 10px;
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      color: #232323;
      margin-bottom: 12px;
      .title {
        font-size: 14px;
        color: #232323;
      }
      .color1 {
        font-size: 14px;
        color: #666666;
      }
      .color2 {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #474f66;
        span {
          width: 7px;
          height: 7px;
          background: #1f61ff;
          border-radius: 3.5px;
          margin-right: 10px;
        }
      }
      .color3 {
        color: #232323;
        font-size: 16px;
        font-weight: bolder;
      }
    }
    .line-box:last-child {
      margin-bottom: 0;
    }
    .line-box2 {
      display: flex;
      justify-content: flex-end;
      padding: 0 15px 0 10px;
    }
  }
  .flag {
    text-align: center;
    color: #999;
    font-size: 14px;
  }
}

.unclaimed {
  width: 82px;
  height: 30px;
  background: #ffa100;
  border-radius: 2px 2px 2px 2px;
  text-align: center;
  line-height: 30px;
  /* margin: 0 auto; */
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
}
.received {
  width: 82px;
  height: 30px;
  background: #d6d6d6;
  border-radius: 2px 2px 2px 2px;
  text-align: center;
  line-height: 30px;
  /* margin: 0 auto; */
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
}
</style>
<style scoped>
.table-box >>> .el-table__header .el-table__cell {
  background-color: #fafbfc;
  color: #474f66;
  font-size: 14px;
  font-weight: bolder;
  text-align: center;
}
.table-box >>> .el-table__body .el-table__cell {
  text-align: center;
  color: #474f66;
  font-size: 14px;
}
</style>
<style lang="scss" scoped>
/* 媒体查询 */
@media only screen and (max-width: 1400px) {
  .homePage {
    .fiex {
      left: 70px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 340px);
      margin-right: 70px;
    }
  }
}

@media only screen and (max-width: 1300px) {
  .homePage {
    .fiex {
      left: 30px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 260px);
      margin-right: 30px;
    }
  }
}

@media only screen and (max-width: 1200px) {
  .homePage {
    .fiex {
      left: 30px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 260px);
      margin-right: 30px;
      .sign-box {
        flex-direction: column;
        .sign {
          width: 100%;
        }
      }
    }
  }
}

@media only screen and (max-width: 1000px) {
  .homePage {
    .fiex {
      display: none;
    }
    .right {
      width: calc(100% - 30px);
      margin-right: 15px;
    }
  }
}

@media only screen and (max-width: 750px) {
  .homePage {
    .screen-box {
      display: none;
    }
    .table-box {
      display: none;
    }
    //筛选移动端
    .screen-box2 {
      display: flex;
    }
    .list-box {
      display: block;
    }
  }
}
</style>